import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { OfferRequirementsSectionData } from './offer-requirements-section.model';
import { SubmissionDetailsActionsService } from '../../../actions/submission-details-actions.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifbp-offer-requirements-section',
    templateUrl: './offer-requirements-section.component.html',
    styleUrls: ['./offer-requirements-section.component.scss'],
    standalone: false
})
export class OfferRequirementsSectionComponent implements OnInit, OnChanges {
  isDataAvailable: boolean;
  isClosingDocsRequirementsAvailable: boolean;
  isNextStepsRequirementsAvailable: boolean;
  isClosingDocsRequirementsMarkedAsInvalid: boolean;

  @Input()
  data: OfferRequirementsSectionData;

  constructor(private readonly actions: SubmissionDetailsActionsService) { }

  ngOnInit(): void {
    this.actions.markClosingDocumentsSectionAsInvalid$.pipe(untilDestroyed(this))
      .subscribe((isInvalid: boolean) => {
        this.isClosingDocsRequirementsMarkedAsInvalid = isInvalid;
      })
  }
  ngOnChanges(): void {
    this.isClosingDocsRequirementsAvailable = !!this.data?.requirements?.closingDocuments?.length;
    this.isNextStepsRequirementsAvailable = !!this.data?.requirements?.nextSteps?.length;
    this.isDataAvailable = this.data && (this.isClosingDocsRequirementsAvailable || this.isNextStepsRequirementsAvailable);
  }
}
